import React from "react";
import { Container, Typography, Divider, Box } from "@mui/material";
import Logo from "../assets/Images/Logo.png";
import Header from "../components/Navbar";
import Footer from "../components/Footer";

const Section = ({ title, children }) => (
  <Box sx={{ mb: 4 }}>
    <Typography variant="h6" fontWeight="bold" gutterBottom>
      {title}
    </Typography>
    <Typography variant="body2" color="textSecondary">
      {children}
    </Typography>
  </Box>
);

const TermsAndConditions = () => {
  return (
    <>
    <Header />
    <Box sx={{ backgroundColor: "#F9FAFB", py: 5 }}>
      <Container maxWidth="md">
        {/* Logo */}
        <Box sx={{ textAlign: "center", mb: 4 }}>
        <Typography
            variant="h6"
            noWrap
            component="a"
            href="/"
            sx={{ mr: 2, mt: 1 }}
          >
            <img alt="logo" src={Logo}></img>
          </Typography>
        </Box>

        {/* Header */}
        <Typography variant="h4" fontWeight="bold" gutterBottom>
          Terms & Conditions
        </Typography>
        <Typography variant="subtitle2" color="textSecondary" gutterBottom>
        Welcome to Ajoo. By accessing or using our app, you agree to comply with and be bound by the following terms and conditions. Please read them carefully.
        </Typography>

        <Divider sx={{ my: 3 }} />

        <Section title="1. Acceptance of Terms">
          By downloading or using Ajoo, you agree to be bound by these Terms & Conditions. If you do not agree, please uninstall and discontinue use of the app.
        </Section>

        <Section title="2. Use of the App">
          You agree to use Ajoo only for lawful purposes. You are responsible for maintaining the confidentiality of your login credentials and all activities that occur under your account.
        </Section>

        <Section title="3. User Content">
          You are solely responsible for content you upload or share. By submitting content, you grant Ajoo a non-exclusive, royalty-free license to use, display, and store your content as needed to provide app functionality.
        </Section>

        <Section title="4. Modifications to Terms">
          Ajoo may update these Terms at any time. Continued use of the app after any changes constitutes your acceptance of the revised Terms.
        </Section>

        <Section title="5. Termination">
          We reserve the right to suspend or terminate your access to Ajoo if you violate any part of these Terms & Conditions.
        </Section>

        <Section title="6. Limitation of Liability">
          Ajoo is provided “as is” without warranties of any kind. We are not liable for any damages resulting from the use or inability to use the app.
        </Section>

        <Section title="7. Governing Law">
          These Terms are governed by the laws of the jurisdiction in which the app is operated. You agree to submit to the exclusive jurisdiction of the courts located there.
        </Section>

        <Section title="8. Contact Us">
          If you have any questions or concerns about these Terms, you can reach us at <strong>ajooomobile@gmail.com</strong>.
        </Section>
      </Container>
    </Box>
    <Footer />
    </>
  );
};

export default TermsAndConditions;
